module.exports = __webpack_public_path__ + "img/15_sp.849f3405.gif";